import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Introducere from './components/Introducere';
import ConcepteBaza from './components/ConcepteBaza';
import Instrumente from './components/Instrumente';
import Strategii from './components/Strategii';
import GestionareaRiscului from './components/GestionareaRiscului';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CtaMijloc from './components/CtaMijloc';

function SectionDivider({ label, icon }: { label: string; icon: string }) {
  return (
    <div
      className="relative w-full flex items-center justify-center py-5 overflow-hidden"
      style={{ background: '#f9f7f4' }}
    >
      <div className="absolute inset-0 flex items-center px-8">
        <div className="flex-1 h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(78,205,196,0.25), transparent)' }} />
      </div>
      <div
        className="relative z-10 flex items-center gap-2.5 px-5 py-2 rounded-full border text-xs font-semibold uppercase tracking-widest"
        style={{
          background: 'white',
          borderColor: 'rgba(78,205,196,0.3)',
          color: '#4ecdc4',
        }}
      >
        <i className={`${icon} text-sm`} />
        {label}
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Inter, sans-serif' }}>

      {/* ══════════════════════════════════
          SUS — SECȚIUNEA DE BAZĂ
      ══════════════════════════════════ */}
      <div id="section-sus">
        <Navbar />
        <Hero />
      </div>

      <SectionDivider label="Conținut Principal" icon="ri-book-open-line" />

      {/* ══════════════════════════════════
          MIJLOC — SECȚIUNILE DE CONȚINUT
      ══════════════════════════════════ */}
      <div
        id="section-mijloc"
        style={{ background: '#ffffff' }}
      >
        <Introducere />
        <ConcepteBaza />
        <Instrumente />
        <Strategii />
        <CtaMijloc />
        <GestionareaRiscului />
        <FAQ />
      </div>

      <SectionDivider label="Footer" icon="ri-layout-bottom-line" />

      {/* ══════════════════════════════════
          JOS — FOOTER
      ══════════════════════════════════ */}
      <div id="section-jos">
        <Footer />
      </div>

    </div>
  );
}
